import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useIsInboundVersion } from '../../hooks/useIsInboundVersion';
import { Search } from '../TopBarSearch/Search';

import s from './TopBar.scss';

export const TopBar: FC = () => {
  const { t } = useTranslation();
  const isInboundVer = useIsInboundVersion();

  return (
    <div className={s.container}>
      <div className={s.title}>
        {isInboundVer
          ? t('app.topBar.title.inbound')
          : t('app.topBar.title.outbound')}
      </div>
      <Search />
      <div style={{ height: 32 }} />
    </div>
  );
};
